/**
 * Returns every existing assignment of `crewId` on any block that overlaps the
 * given block's time window — excluding the block itself. Used to detect
 * double-booking before confirming a new assignment.
 *
 * @param {Array} schedule_blocks   all blocks in the project
 * @param {Array} assignments       all assignments in the project
 * @param {Object} block            the target block we're assigning crew TO
 * @param {string} crewId
 * @returns {Array<{block, assignment}>} list of conflicts
 */
export function findCrewConflicts(schedule_blocks, assignments, block, crewId) {
  if (!block?.start_at || !block?.end_at) return [];
  const s = new Date(block.start_at).getTime();
  const e = new Date(block.end_at).getTime();
  const out = [];
  for (const a of assignments) {
    if (a.crew_member_id !== crewId) continue;
    if (a.schedule_block_id === block.id) continue;
    const b = schedule_blocks.find((bb) => bb.id === a.schedule_block_id);
    if (!b || !b.start_at || !b.end_at) continue;
    const bs = new Date(b.start_at).getTime();
    const be = new Date(b.end_at).getTime();
    // Overlap if NOT (b ends before us OR b starts after us).
    if (be <= s || bs >= e) continue;
    out.push({ block: b, assignment: a });
  }
  return out;
}

/**
 * Returns true if the crew member is marked unavailable on the given date.
 * `unavailable_until` is inclusive — same date counts as unavailable.
 */
export function isCrewUnavailable(crew, dateKey) {
  if (!crew?.unavailable_until || !dateKey) return false;
  return dateKey <= crew.unavailable_until;
}
